<template>
  <ButtonSecondary
    :isDisabled="handleIsButtonDisabled"
    :text="buttonText"
    :type="handleButtonType"
    @click.native="handleButtonClick"
  />
</template>

<script>
import {
  ButtonSecondary,
} from '@jumpcloud/ui-components';

export default {
  name: 'ActionCommandButton',

  components: {
    ButtonSecondary,
  },

  props: {
    buttonText: {
      type: String,
      required: true,
    },
    buttonType: {
      type: String,
      required: true,
    },
    handleClick: {
      type: Function,
      required: true,
    },
    item: {
      type: Object,
      required: true,
    },
  },

  computed: {
    handleButtonType() {
      let type;
      switch (this.buttonType) {
        case 'run':
          type = 'secondary';
          break;
        case 'delete':
          type = 'error';
          break;
        default:
          type = null;
          break;
      }
      return type;
    },

    handleIsButtonDisabled() {
      return this.buttonType === 'run' && this.item.launchType === 'registration-trigger';
    },
  },

  methods: {
    handleButtonClick(e) {
      if (this.buttonType === 'delete' || this.item.launchType !== 'registration-trigger') {
        this.handleClick(e, this.item);
      }
    },
  },
};
</script>
